import { useCallback, useEffect, useRef, useState } from "react";
import { useParticipantContext } from "../../../sit-in/hooks/participant-context";
import { ControllerSitInSortWrapper } from "../../../sit-in/style";
import { MobileControllerBackgroundBox } from "../clock/style";
import {
  MobileControllerSitInButtonWrapper,
  MobileControllerSitInHeader,
  MobileControllerSitInHeaderTabs,
  MobileControllerSitInInputWrapper,
  MobileTimerControllerSitInWrapper,
  MobileControllerSitInMemberListBody,
  MobileControllerSitInMemberListHeader,
  MobileControllerSitInMemberListWrapper,
  MobileControllerSitInMemberListItem,
} from "./style";
import { TimerControllerDropBox } from "../../../../style";
import { SitInTab } from "../../../sit-in/hooks/use-tournament-participant";
import ControllerSitInReservationPopup from "../../../sit-in/components/reservation";
import { EntryType } from "../../../../../../api/settlement";
import { TournamentParticipationDto } from "../../../../../../api/tournament-participant";
import { MobileControllerSitInMemberHistory } from "../member-history";

const MobileTimerControllerSitIn = () => {
  const {
    tab,
    setTab,
    sort,
    setSort,
    isLoading,
    hasMoreData,
    currentPage,
    setCurrentPage,
    searchNickname,
    setSearchNickname,
    onSearchClick,
    participantList,
    sitInCount,
    sitOutCount,
    isReservationPopup,
    setIsReservationPopup,
    isHistoryPopup,
    handleBuyIn,
    handleSitOut,
    handleOpenHistory,
    handleReEntry,
    handleParticipantDelete,
  } = useParticipantContext();
  // list height
  const [listBodyHeight, setListBodyHeight] = useState(0);
  // 드롭다운 상태
  const [openSitInSort, setOpenSitInSort] = useState<boolean>(false);
  const [openMoreId, setOpenMoreId] = useState<number>(-1);
  // 스크롤 페이징
  const observerRef = useRef<HTMLDivElement>(null);

  const tabs = [
    { name: `싯인(${sitInCount})`, value: SitInTab.SIT_IN },
    { name: `싯아웃(${sitOutCount})`, value: SitInTab.SIT_OUT },
  ];

  const sitInSortList = [
    { name: "가나다순", value: "name" },
    { name: "최신순", value: "id" },
  ];

  // 싯인 리스트 높이 지정
  useEffect(() => {
    const updateHeight = () => {
      setListBodyHeight(window.innerHeight - 260 - 96);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  // 스크롤 페이징
  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const target = entries[0];
      if (target.isIntersecting && hasMoreData && !isLoading) {
        setCurrentPage(currentPage + 1);
      }
    },
    [hasMoreData, isLoading]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 1.0,
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [handleObserver]);

  // 삭제 / 싯인 목록 보기
  const handleMore = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    if (openMoreId === id) {
      setOpenMoreId(-1);
    } else {
      setOpenMoreId(id);
    }
  };

  // 삭제 로직
  const handleMoreItem = (item: TournamentParticipationDto) => {
    setOpenMoreId(-1);
    handleParticipantDelete(item.memberId);
  };

  const moreItems = [{ name: "삭제", onClick: handleMoreItem }];

  return (
    <MobileTimerControllerSitInWrapper onClick={(e) => handleMore(-1, e)}>
      {/* 예약자 목록 팝업 */}
      {isReservationPopup && <ControllerSitInReservationPopup />}
      {/* 이용 내역 목록 팝업 */}
      {isHistoryPopup && <MobileControllerSitInMemberHistory />}
      <MobileControllerBackgroundBox>
        <MobileControllerSitInHeader>
          <div className="box">
            <MobileControllerSitInInputWrapper>
              <input
                value={searchNickname}
                onChange={(e) => setSearchNickname(e.target.value)}
                placeholder="닉네임을 검색하세요."
              />
              <img
                src="/image-web/timer-config/searchIcon.svg"
                alt="search"
                onClick={onSearchClick}
              />
            </MobileControllerSitInInputWrapper>
            <ControllerSitInSortWrapper isAbsolute={false}>
              <div
                className="box"
                onClick={() => setOpenSitInSort(!openSitInSort)}
              >
                {sort === "id" ? "최신순" : "가나다순"}
                <img src="/image-web/controller/drop_down.svg" alt="down" />
              </div>
              {openSitInSort && (
                <TimerControllerDropBox top="40px">
                  {sitInSortList.map((item, i) => (
                    <div
                      className={`item ${
                        item.value === sort ? "selected" : ""
                      }`}
                      onClick={() => {
                        setSort(item.value);
                        setOpenSitInSort(false);
                      }}
                      key={i}
                    >
                      {item.name}
                    </div>
                  ))}
                </TimerControllerDropBox>
              )}
            </ControllerSitInSortWrapper>
          </div>
          <div className="box">
            <MobileControllerSitInHeaderTabs>
              {tabs.map((item, index) => (
                <div
                  key={index}
                  className={`button ${tab === item.value ? "select" : ""}`}
                  onClick={() => setTab(item.value)}
                >
                  {item.name}
                </div>
              ))}
            </MobileControllerSitInHeaderTabs>
            <MobileControllerSitInButtonWrapper>
              <div
                className="button"
                onClick={() => setIsReservationPopup(true)}
              >
                예약
              </div>
              <div className="button" onClick={handleBuyIn}>
                추가
              </div>
            </MobileControllerSitInButtonWrapper>
          </div>
        </MobileControllerSitInHeader>
      </MobileControllerBackgroundBox>
      <MobileControllerSitInMemberListWrapper>
        <MobileControllerSitInMemberListHeader>
          <div className="name">닉네임</div>
          <div className="count">리엔트리</div>
          <div className="count">애드온</div>
          <div className="button" />
          <div className="button" />
          <div className="more" />
        </MobileControllerSitInMemberListHeader>
        <MobileControllerSitInMemberListBody height={`${listBodyHeight}px`}>
          {participantList.map((item, index) => (
            <MobileControllerSitInMemberListItem
              key={index}
              ref={index === currentPage * 19 ? observerRef : undefined}
              onClick={() => handleOpenHistory(item)}
            >
              <div className="name">{item.nickname}</div>
              <div className="count">{item.rebuyCount}</div>
              <div className="count">
                {item.addonIsCount}
                {item.addonNotCount ? `(${item.addonNotCount})` : ""}
              </div>
              {tab === SitInTab.SIT_IN ? (
                <>
                  <div
                    className="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReEntry(item, EntryType.RE_BUY);
                    }}
                  >
                    리엔트리
                  </div>
                  <div
                    className="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReEntry(item, EntryType.ADD_ON);
                    }}
                  >
                    애드온
                  </div>
                  <div
                    className="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSitOut(item, true);
                    }}
                  >
                    싯아웃
                  </div>
                  <div className="more" onClick={(e) => handleMore(item.id, e)}>
                    <img src="/image-web/controller/more.svg" alt="more" />
                    <ControllerSitInSortWrapper isAbsolute={true}>
                      {openMoreId === item.id && (
                        <TimerControllerDropBox top="0px" left="-90px">
                          {moreItems.map((more, i) => (
                            <div
                              className="item"
                              onClick={() => more.onClick(item)}
                              key={i}
                            >
                              {more.name}
                            </div>
                          ))}
                        </TimerControllerDropBox>
                      )}
                    </ControllerSitInSortWrapper>
                  </div>
                </>
              ) : (
                <div className="return">
                  <img
                    src="/image-web/tournament/reset.svg"
                    alt="reset"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSitOut(item, false);
                    }}
                  />
                </div>
              )}
            </MobileControllerSitInMemberListItem>
          ))}
        </MobileControllerSitInMemberListBody>
      </MobileControllerSitInMemberListWrapper>
    </MobileTimerControllerSitInWrapper>
  );
};

export default MobileTimerControllerSitIn;
